// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvze3t{padding-left:var(--ds-space-0,0)}\n._19pkpxbi{margin-top:var(--ds-space-200,1pc)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._1wpz1fhb{align-self:stretch}\n._2lx21bp4{flex-direction:column}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._otyru2gc{margin-bottom:var(--ds-space-100,8px)}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}", ""]);
// Exports
module.exports = exports;
